<template>
  <div class="b-ate-tree-list caption px-3">
    <v-skeleton-loader :loading="skeleton" type="sentences">
      <template v-for="(group, index) in groupList">
        <!-- <v-divider v-if="index" :key="`${index}-divider`" /> -->

        <div :key="index" class="pb-0">
          {{ group.label }}
          <v-chip x-small class="pa-2">
            {{ group.count }}
          </v-chip>
        </div>
      </template>
    </v-skeleton-loader>
  </div>
</template>

<script>
import { CancelToken, isCancel } from 'axios'
import debounce from 'lodash/debounce'
import memoize from 'lodash/memoize'
import { AteUtilsApi } from '@/api/resources'
import { DEBOUNCE_TIMEOUT } from '@/helpers/enums/params'

const resolverMemoize = (...args) => args.filter(Boolean).join('###')

export default {
  name: 'BAteTreeListCount',
  props: {
    skeleton: Boolean,
    regions: {
      type: Array,
      default: () => [],
    },
    municipalities: {
      type: Array,
      default: () => [],
    },
    schools: {
      type: Array,
      default: () => [],
    },
    counts: {
      type: Object,
      validator: (prop) => (
        prop
        && 'region_count' in prop
        && 'municipality_count' in prop
        && 'school_count' in prop
      ),
    },
  },
  data: (vm) => ({
    countsInner: vm.counts || {
      region_count: vm.regions?.length,
      municipality_count: vm.municipalities?.length,
      school_count: vm.schools?.length,
    },
  }),
  computed: {
    groupList() {
      const { countsInner } = this

      return [
        {
          label: 'Регионы',
          count: countsInner.region_count,
          type: 'regions',
        },
        {
          label: ' Муниципальные районы',
          count: countsInner.municipality_count,
          type: 'municipalities',
        },
        {
          label: 'Образовательные организации',
          count: countsInner.school_count,
          type: 'schools',
        },
      ]
    },
  },
  watch: {
    regions: 'onChangeAte',
    municipalities: 'onChangeAte',
    schools: 'onChangeAte',
    counts(value) {
      this.countsInner = value
    },
  },
  created() {
    this.onGetNormilizeDebounced = debounce(
      this.onGetNormilize,
      2 * DEBOUNCE_TIMEOUT,
    )

    this.onGetNormilizeDebounced()
  },
  beforeDestroy() {
    // this.cleanupCache()
  },
  methods: {
    getNormilize: memoize(async function getNormilize(regionIds, municipalityIds, schoolIds) {
      void this.cancelTokenSource?.cancel(this.$options.name)
      this.cancelTokenSource = CancelToken.source()
      const cancelToken = this.cancelTokenSource.token

      const api = new AteUtilsApi()
      const params = {
        region_ids: regionIds,
        municipality_ids: municipalityIds,
        school_ids: schoolIds,
      }

      try {
        const { data } = await api.normalize(params, { cancelToken })
        return data
      } catch (e) {
        if (!isCancel(e)) {
          this.$notice.errors(e)
        }
        setTimeout(this.cleanupCache)
      }

      return null
    }, resolverMemoize),
    async onGetNormilize() {
      if (this.counts) return

      if (!this.parent_mode) {
        this.countsInner = {
          region_count: this.regions?.length,
          municipality_count: this.municipalities?.length,
          school_count: this.schools?.length,
        }
        return
      }

      const regionIds = this.regions.map((_) => _.id)
      const municipalityIds = this.municipalities.map((_) => _.id)
      const schoolIds = this.schools.map((_) => _.id)

      const countsInner = await this.getNormilize(regionIds, municipalityIds, schoolIds)
      if (countsInner) this.countsInner = countsInner
    },
    onChangeAte() {
      this.onGetNormilizeDebounced()
    },
    cleanupCache() {
      Object.values(this.$options.methods)
        .forEach((method) => { method.cache?.clear() })
    },
  },
}
</script>

<style lang="scss">

.b-ate-tree-list {
  .v-list-group__items > .v-list-item {
    padding-left: 36px !important;
  }
}
</style>
